module.exports = __webpack_public_path__ + "static/edge-of-the-universe-f1f16c29560625dd031dafba0cf0665f.jpg";